export class StringHelper {
    public static camelCaseToUpperSnakeCase(value: string) {
        return value
            ?.replace(/[A-Z]/g, (letter) => `_${letter}`)
            .toUpperCase()
            .substring(1);
    }

    public static decapitalize(value: string) {
        return value.substring(0, 1).toLowerCase() + value.substring(1);
    }

    public static wordSearch(value: string, term: string) {
        return term
            .toLocaleLowerCase()
            .split(' ')
            .every((part) => value.toLocaleLowerCase().includes(part));
    }
}
